import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReRouteLayoutComponent } from './components/re-route-layout/re-route-layout.component';
import { AuthGuard } from '../auth/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: ReRouteLayoutComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReRouteRoutingModule {}
